export enum AnalyticEvent {
	APP_LOAD = 'app_load',
	GOOGLE_SIGN_IN = 'sign_in_google',
	LOGIN = 'login',
	SIGN_UP = 'sign_up',
	SIGN_OUT = 'sign_out',
	PASSWORD_RESET = 'password_reset',
	PASSWORD_CHANGE = 'password_change',
	PROFILE_UPDATE = 'profile_update',
	PHONE_NUMBER_UPDATE = 'phone_number_update',
	PHONE_NUMBER_SIGN_UP = 'phone_number_sign_up',
	PHONE_NUMBER_SIGN_IN = 'phone_number_sign_in',
}
